<div class="background">
	<div class="container">
		<h1 class="main-title">
			Terms and conditions
		</h1>

		<p class="dark-paragraph mb-3">
			Ju lutemi lexoni me kujdes këto terma dhe kushte të përdorimit përpara se
			të përdorni këtë webfaqe.
		</p>
		<p class="dark-paragraph mb-3">
			Termat dhe Kushtet e përdorimit të shkruar në këtë Webfaqe do të
			menaxhojnë përdorimin tuaj të faqes sonë të internetit Aksidentet Rrugore.
			Termat dhe kushtet e Shoqatës së Sigurimeve të Kosovës përbëhen dhe
			pershkruajnë të drejtat dhe detyrimet e juaja ligjore dhe kontraktuale të
			cilat lindin në momentin që ju përdorni këtë webfaqe.
		</p>
		<p class="dark-paragraph mb-3">
			Çdo person i cili përdor Webfaqen do të konsiderohet se ka lexuar, kuptuar
			dhe pranuar shprehimisht këto terma dhe kushte të cilat do të jenë të
			detyrueshme për përdoruesin e webfaqes. Duke përdorur këtë webfaqe,
			supozojmë se i pranoni këto terma dhe dhe kushte. Mos vazhdoni me
			përdorimin e webfaqes nëse nuk jeni dakord me të gjitha termat dhe kushtet
			e përcaktuara në këtë webfaqe.
		</p>
		<p class="dark-paragraph mb-3">
			Këto terma dhe kushte të tanishme dhe ato shtesë (që do të shtohen në të
			ardhmen) ose dokumentet që mund të postohen në webfaqe herë pas here, janë
			shprehimisht të aplikueshme. Ne rezervojmë të drejtën, sipas bindjes tonë,
			të bëjmë ndryshime ose modifikime në këto terma dhe kushte në çdo kohë dhe
			për çfarëdo arsye.
		</p>
		<p class="dark-paragraph mb-5">
			Është përgjegjësia juaj për të rishikuar në mënyrë periodike këto terma
			dhe kushte me qëllim që të qëndroni të informuar për ndryshimet. Ju do të
			jeni subjekt i termave dhe kushteve të ndryshuara andaj do të kërkohet që
			ju të jeni të informuar dhe ti keni pranuar ndryshimet e termave dhe
			kushteve, kështu që përdorimi juaj i vazhdueshëm i webfaqes pas datës së
			postimit të termave dhe kushteve të ndryshuara do të konsiderohet si fakt
			se ju jeni të informuar dhe i keni pranuar.
		</p>

		<p class="heading4 mb-3">
			PËRDORUESI I WEBFAQES DHE PËRFAQËSIMI
		</p>

		<p class="dark-paragraph">
			• Me faktin e përdorimit të webfaqes ju garantoni se:
		</p>
		<p class="dark-paragraph">
			• jeni në moshë të madhore (të paktën tetëmbëdhjetë (18) vjeç ose më i
			vjetër) për të përdorur shërbimet tona, webfaqen tonë dhe mund të krijoni
			detyrime ligjore të obligueshme nga përdorimi i webfaqes tonë;
		</p>
		<p class="dark-paragraph">
			• ju keni aftësinë juridike dhe të veprimit për t'i zbatuar këto terma dhe
			kushte;
		</p>
		<p class="dark-paragraph">
			• nëse jeni i mitur (nën 18 vjeç), ju keni marrë lejen prindërve apo
			kujdestarit për të përdorur webfaqen;
		</p>

		<p class="dark-paragraph mb-5">
			• ju nuk do të hyni në webfaqe përmes mjeteve të automatizuara ose jo
			njerëzore.
		</p>

		<p class="heading4 mb-3">
			PRANIMI JUAJ I KËTYRE TERMAVE DHE KUSHTEVE
		</p>

		<p class="dark-paragraph mb-5">
			Me faktin e përdorimin e webfaqes tonë, nënkuptohet se ju i pranoni këto
			terma dhe kushte. Ju pranoni që në emër të juajin personalisht dhe atyre
			që ju përfaqësoni t'i respektoni të gjitha termat dhe kushtet. Lidhur me
			shërbimet online, Shoqata e Sigurimeve të Kosovës rezervojnë të drejtën,
			sipas gjykimit , të ndryshoj, shtoj ose heq çdo pjesë të këtyre kushteve
			të përdorimit që lidhen me Webfaqen, tërësisht ose pjesërisht. Nëse
			vazhdoni të përdorni shërbimet online pas kësaj, përdorimi juaj i
			vazhdueshëm i shërbimeve është pranimi juaj i ndryshimeve dhe marrëveshjes
			për t'u lidhur me kushtet e ndryshuara. Nëse nuk jeni dakord me
			ndryshimet, ju pranoni të ndërpresni përdorimin tuaj.
		</p>

		<p class="heading4 mb-3">
			VEPRIMET E NDALUARA
		</p>
		<p class="dark-paragraph mb-1">
			Ju nuk mund të përdorni webfaqen për ndonjë qëllim tjetër përveç atij për
			të cilin ne e kemi vënë në dispozicion.
		</p>
		<p class="dark-paragraph mb-3">Si përdorues i faqes, ju pranoni të mos:</p>

		<p class="dark-paragrapH">
			• merrni të dhëna në mënyrë sistematike ose përmbajtje tjetër nga
			webfaqja, pa leje me shkrim nga ne;
		</p>
		<p class="dark-paragraph">
			• e përdorni webfaqen për të reklamuar, ofruar ose për të shitur mallra
			dhe shërbime, pa lejen me shkrim nga ne;
		</p>
		<p class="dark-paragraph">
			• e anashkaloni, çaktivizoni ose ndërhyni ndryshe në sigurinë e webfaqes;
		</p>
		<p class="dark-paragraph">
			• ndërhyni, prishni ose të krijoni një ngarkesë të dëmshme në webfaqe ose
			rrjetet ose shërbimet e lidhura me faqen;
		</p>
		<p class="dark-paragraph">
			• e përdorni çfardo informacioni të marrë nga webfaqja në mënyrë që të
			ngacmoni, abuzoni ose dëmtoni një person tjetër;
		</p>
		<p class="dark-paragraph">
			• veproni me anë të deshifrimit ose veprimeve të tjera të ngjashmë për të
			kërcënuar ndonjë prej programeve kompjuterike që përbëjnë ose krijojnë një
			pjesë të webfaqes;
		</p>
		<p class="dark-paragraph">
			• ngacmoni, fyejni, frikësoni ose kërcënoni ndonjë nga punonjësit e
			angazhuar në kompani;
		</p>
		<p class="dark-paragraph">
			• e fshini njoftimin për të drejtat e autorit ose të drejtat e tjera nga
			çdo përmbajtje;
		</p>
		<p class="dark-paragrapH">
			• kopjoni ose adaptoni softuerin e webfaqes, duke përfshirë por jo
			kufizuar në Flash, PHP, HTML, JavaScript ose kod tjetër;
		</p>
		<p class="dark-paragraph">
			• ngarkoni ose transmetoni viruse ose materiale të tjera, përfshirë
			përdorimin e shkronjave tepër të mëdha dhe spamming (postimi i vazhdueshëm
			i tekstit përsëritës), që ndërhyn në përdorimin e pandërprerë të çdo pale;
		</p>
		<p class="dark-paragraph">
			• ngarkoni ose transmetoni (çdo përpjekje për të ngarkuar ose transmetuar)
			çdo material që vepron si një mekanizëm pasiv ose aktiv i mbledhjes së
			informacionit ose transmetimit, duke përfshirë pa kufizime, formate të
			qarta të shkëmbimit grafik ('gif'), 1 × 1 pixel, defekte në internet,
			cookie, ose pajisje të tjera të ngjashme (nganjëherë referuar si 'spyware'
			ose 'mekanizma pas grumbullimit pasiv' ose 'PC');
		</p>
		<p class="dark-paragraph">
			• e përdorni webfaqen në kundërshtim me ligjet ose rregulloret në fuqi;
			dhe
		</p>
		<p class="dark-paragraph mb-5">
			• e përdorni webfaqen tonë për ndonjë qëllim të paligjshëm ose të
			paautorizuar.
		</p>

		<p class="heading4 mb-3">
			LIDHJET ME WEBFAQE TË TJERA TË INTERNETIT (WEBFAQE TË PALËVE TË TRETA)
		</p>
		<p class="dark-paragraph mb-2">
			Në webfaqe mund të ketë lidhje në webfaqe të tjera të internetit ('faqet e
			palëve të treta'), si dhe artikuj, fotografi, tekst, grafika, fotografi,
			dizajne, muzikë, tingull, video, informacion, aplikacione, softuer dhe
			përmbajtje ose sende të tjera që i përkasin ose kanë prejardhje nga
			webfaqet e palëve të treta.
		</p>
		<p class="dark-paragraph mb-2">
			Ju lutem vini re se këto lidhje janë të publikuara vetëm për referencën
			tuaj dhe se webfaqe e palëve të treta dhe përmbajtja e tyre nuk
			monitorohen ose kontrollohen për saktësinë, përshtatshmërinë ose
			përmbajtjen nga ne dhe ne nuk jemi në asnjë rast përgjegjës për webfaqet e
			palëve të treta përfshirë por duke mos u kufizuar në: përmbajtjen,
			saktësinë, ofendimin, mendimet, besueshmërinë, praktikat e privatësisë,
			ose politikat e tjera në webfaqe të tilla.
		</p>
		<p class="dark-paragraph mb-2">
			Tutje është në vullnetin tuaj nëse ju do të merrni masa paraprake për të
			siguruar që çdo lidhje që ju zgjidhni ose softuer që shkarkoni (qoftë nga
			kjo faqe në internet ose faqet e tjera të internetit) është pa viruse e
			kërcënime të tjera për sigurinë e internetit tuaj.
		</p>
		<p class="dark-paragraph mb-2">
			Përfshirja, lidhja me të, ose lejimi i përdorimit ose instalimit të ndonjë
			webfaqe të palëve të treta ose ndonjë përmbajtje të palëve të treta nuk
			nënkupton miratimin ose miratimin e tyre nga ne. Nëse vendosni të
			largoheni nga webfaqja jonë dhe të hyni në webfaqet e palëve të treta ose
			të përdorni ose instaloni ndonjë përmbajtje të palëve të treta, ju e bëni
			këtë me rrezikun tuaj, dhe duhet të jeni të vetëdijshëm se në ato raste
			nuk vlejnë këto terma dhe kushte.
		</p>
		<p class="dark-paragraph mb-2">
			Ju duhet të rishikoni termat dhe politikat e zbatueshme, përfshirë
			praktikat e privatësisë dhe mbledhjes së të dhënave, të çdo webfaqe në
			internet.
		</p>
		<p class="dark-paragraph mb-5">
			Ju me vetëdije të plotë pranoni që ne nuk miratojmë produktet ose
			shërbimet e ofruara në webfaqet e palëve të treta dhe ju do të na
			përjashtoni nga çdo dëm i shkaktuar nga blerja e produkteve ose shërbimeve
			të tilla.
		</p>

		<p class="heading4 mb-3">
			VLERËSIMET DHE KOMENTET
		</p>

		<p class="dark-paragraph mb-3">
			Në webfaqen tonë mund të ketë hapësira për të lënë komente ose vlerësime.
			Kur shkruani një koment ose vlerësim lidhur me webfaqen ose Shoqatën,
			duhet të respektoni kriteret e mëposhtme:
		</p>
		<p class="dark-paragraph">
			• vlerësimet tuaja nuk duhet të përmbajnë fyerje ose gjuhë abuzive,
			raciste, fyese ose urrejtje;
		</p>
		<p class="dark-paragraph">
			• vlerësimet tuaja nuk duhet të përmbajnë referenca diskriminuese bazuar
			në fe, racë, gjini, origjinë kombëtare, moshë, status martesor, orientim
			seksual ose paaftësi;
		</p>
		<p class="dark-paragraph">
			• vlerësimet tuaja nuk duhet të përmbajnë referenca për veprimtari të
			paligjshme;
		</p>
		<p class="dark-paragraph">
			• nëse ju jepni komente negative, ju nuk duhet të jeni të lidhur me
			konkurrencën;
		</p>
		<p class="dark-paragraph">
			• ju nuk mund të postoni ndonjë deklaratë të pavërtet ose mashtruese; dhe
		</p>
		<p class="dark-paragraph mb-3">
			• ju nuk mund të organizoni një fushatë duke inkurajuar të tjerët të
			postojnë vlerësime, pozitive apo negative.
		</p>

		<p class="dark-paragraph mb-3">
			Ne mund të pranojmë, refuzojmë ose fshijmë komentet dhe vlerësimet sipas
			bindjes tonë. Ne nuk kemi asnjë detyrim për të shqyrtuar
			vlerësimet/komentet ose për të fshirë vlerësimet/komentet edhe nëse dikush
			i konsideron vlerësimet të kundërshtueshme. Komentet dhe vlerësimet nuk
			miratohen nga ne dhe nuk përfaqësojnë domosdoshmërisht mendimet tona ose
			pikëpamjet e ndonjë prej bashkëpunëtorëve tanë ose partnerëve tanë.
		</p>
		<p class="dark-paragraph mb-5">
			Ne nuk marrim përgjegjësi për ndonjë koment ose për ndonjë pretendim,
			detyrim ose humbje që rezulton nga ndonjë koment/vlerësim. Duke postuar
			një vlerësim/koment, me këtë ju na jepni një të drejtë të përhershme,
			jo-ekskluzive, në të gjithë botën, plotësisht të paguar, të caktueshme,
			dhe të publikueshme, për licencimin e riprodhimit, modifikimit,
			përkthimit, transmetimit me çfarëdo mënyre, shfaqjen, performancën, dhe /
			ose shpërndani të gjithë përmbajtjen në lidhje me komentin/vlerësimet.
		</p>

		<p class="heading4 mb-3">
			RRJETET SOCIALE
		</p>
		<p class="dark-paragraph mb-3">
			Ju mund ta lidhni llogarinë tuaj të webfaqes me llogaritë e tjera online
			që keni me ofruesit e shërbimeve të palëve të treta (tash e tutje, një
			'Llogari e Palëve të Treta') nga secila: (1) duke na ofruar informacionet
			e kyçjes në logarinë tuaj të palëve të treta përmes faqes; ose (2) duke na
			lejuar të qasemi në llogarinë tuaj të palëve të treta, siç lejohet në bazë
			të termave dhe kushteve të zbatueshme që rregullojnë përdorimin tuaj të
			secilës llogari të palëve të treta.
		</p>
		<p class="dark-paragraph mb-3">
			Duke na lejuar hyrjen në çdo llogari të palëve të treta, ju e kuptoni se
			(1) ne mund të hyjmë, të marrim dhe të ruajmë (nëse është e aplikueshme)
			çdo përmbajtje që ju keni vënë dhe ruajtur në llogarinë tuaj të palëve të
			treta ('Rrjeti Social Përmbajtja”) përfshirë pa kufizime listat e shokëve
			dhe (2) ne mund t'i ngarkojmë dhe marrim nga ato llogari informacion
			shtesë në atë masë që ju njoftoheni kur lidhni llogarinë tuaj në webfaqen
			tonë me llogarinë e palës së tretë.
		</p>
		<p class="dark-paragraph mb-5">
			Ju lutemi vini re që marrëdhënia juaj me ofruesit e shërbimeve të palëve
			të treta lidhur me llogarinë tuaj te ta është e rregulluar eksluzivisht
			nga marrëveshje juaj me ofruesit e këtyre shërbimeve.
		</p>

		<p class="heading4 mb-3">
			REKLAMUESIT
		</p>
		<p class="dark-paragraph mb-3">
			Ne mund të lejojmë që reklamuesit e ndryshëm të shfaqin reklamat e tyre
			dhe informacione të tjera në webfaqen tonë, siç janë reklamat në shiritin
			anësor ose reklamat e banderolave. Nëse jeni reklamues, do të merrni
			përgjegjësinë e plotë për çdo reklamë apo shërbim që vendosni në webfaqe
			ose produkte të shitura përmes këtyre reklamave.
		</p>
		<p class="dark-paragraph mb-5">
			Për më tepër, si reklamues, ju garantoni që posedoni të gjitha të drejtat
			për të vendosur reklama në webfaqe, duke përfshirë, por pa u kufizuar
			vetëm në, të drejtat e pronësisë intelektuale, të drejtat e publicitetit
			dhe të drejtat e kontratës.
		</p>
		<p class="heading4 mb-3">
			MENAXHIMI I WEBFAQES
		</p>
		<p class="dark-paragraph mb-3">
			Ne rezervojmë të drejtën, por jo detyrimin, që:
		</p>
		<p class="dark-paragraph">
			• të monitorojmë webfaqen për shkelje të këtyre termave dhe kushteve;
		</p>
		<p class="dark-paragraph">
			• të ndërmarrim veprime të duhura ligjore kundër kujtdo që, sipas gjykimit
			tonë, shkel ligjin ose këto terma dhe kushte, përfshirë pa kufizim,
			raportimin e përdoruesit të tillë tek autoritetet e zbatimit të ligjit;
			dhe
		</p>
		<p class="dark-paragraph mb-5">
			• sipas gjykimit tonë dhe pa asnjë kufizim, njoftim ose përgjegjësi, të
			heqim nga webfaqja ose të çaktivizojmë të gjitha dosjet dhe përmbajtjet që
			janë me madhësi të tepërt ose janë në ndonjë mënyrë të rëndë për sistemet
			tona.
		</p>

		<p class="heading4 mb-3">
			VLEFSHMËRIA E TERMAVE DHE KUSHTEVE
		</p>

		<p class="dark-paragraph mb-3">
			Këto terma dhe kushte do të mbeten në fuqi dhe me efekt vleshmërie të
			plotë përderisa ju e përdorni webfaqen.
		</p>
		<p class="dark-paragraph mb-5">
			Pa kufizuar ose ndërhyrë në ndonjë dispozitë tjetër të këtyre termave dhe
			kushteve, ne e rezevojmë të drejtën ekskluzive dhe pa ndonjë njoftim për
			ju apo përgjegjësi ndaj jush, ta ndalojmë çasjen në webfaqen tonë (duke
			përfshirë bllokimin e IP adresave të caktuara) të ndonjë përsoni për
			çfardo arsye ose pa arsye.
		</p>
		<p class="heading4 mb-3">
			NDRYSHIMET DHE NDËRPRERJET NË WEBFAQE
		</p>
		<p class="dark-paragraph mb-3">
			Ne rezervojmë të drejtën ekskluzive të ndryshojmë, shtojmë ose heqim
			përmbajtjen e webfaqes në çdo kohë pa paralajmërim. Sidoqoftë, ne nuk kemi
			asnjë detyrim të ndryshojmë ndonjë informacion në webfaqen tonë. Ne
			gjithashtu rezervojmë të drejtën të ndryshojmë ose ndërpresim tërë ose një
			pjesë të webfaqes pa njoftim në çdo kohë.
		</p>
		<p class="dark-paragraph mb-3">
			Ne nuk mund të garantojmë që faqja të jetë e disponueshe në çdo kohë. Ne
			mund të kemi hardware, software ose probleme të tjera ose kemi nevojë për
			të kryer mirëmbajtjen e webfaqes, duke shkaktuar ndërprerje, vonesa ose
			gabime.
		</p>
		<p class="dark-paragraph mb-5">
			Ju pranoni që ne nuk kemi asnjë përgjegjësi për çfarëdo humbje, dëmtimi
			ose pakënaqësi të shkaktuar nga pamundësia juaj për të hyrë ose për të
			përdorur faqen.
		</p>
		<p class="heading4 mb-3">
			PËRJASHTIMET DHE KUFIZIMET E PËRGJEGJËSISË SË SHOQATËS
		</p>
		<p class="dark-paragraph mb-3">
			Informacioni në lidhje me produktet e sigurimit të publikuara dhe çështje
			tjera në këtë webfaqe mund të përfshijë pasaktësi ose gabime, përfshirë
			gabime të dhënave. Shoqata e Sigurimeve të Kosovës nuk garanton saktësinë
			e tij, dhe lirohet nga të gjitha përgjegjësitë për gabime ose pasaktësi të
			tjera eventuale në lidhje me informacionin të aksidenteve të publikuara në
			këtë webfaqe (përfshirë, pa kufizime, aksidentet, datat, etj.). Për më
			tepër, Shoqata me anë të këtyre kushteve rezervon shprehimisht të drejtën
			të korrigjojë çdo gabim të dhënave në webfaqen tonë.
		</p>
		<p class="dark-paragraph mb-3">
			Ne nuk ofrojmë asnjë garanci në lidhje me saktësinë ose përmbajtjen e
			webfaqes ose përmbajtjen e webfaqeve tjera të lidhura me webfaqen tonë dhe
			nuk do të pranojmë asnjë përgjegjësi për:
		</p>
		<p class="dark-paragraph">
			• gabime, pasaktësi të përmbajtjes dhe materialit;
		</p>
		<p class="dark-paragraph">
			• dëmtim personal ose dëmtimi të pasurisë, i çfarëdo natyre që vjen nga
			hyrja dhe përdorimi juaj i webfaqes tonë;
		</p>
		<p class="dark-paragraph">
			• çdo qasje të paautorizuar në ose përdorim i serverëve tanë
		</p>
		<p class="dark-paragraph">
			• çdo ndërprerje të webfaqes tonë ose ndërprerje e transmetimit në webfaqe
			tonë;
		</p>
		<p class="dark-paragraph">
			• çdo virus që mund të transmetohet në ose përmes webfaqes;
		</p>
		<p class="dark-paragraph">
			• çdo gabim ose lëshim në çfarëdo përmbajtje dhe material ose për ndonjë
			humbje ose dëmtim të çfarëdo lloji të ndodhur si rezultat i përdorimit të
			webfaqes, postimeve, të trasametuara ose të vëna në dispozicion ndryshe
			përmes faqes; dhe
		</p>
		<p class="dark-paragraph mb-3">
			• ne nuk ofrojmë garanci ose marrim përgjegjësi për çdo produkt ose
			shërbim të reklamuar ose ofruar nga një palë e tretë përmes webfaqes tonë,
			ose ndonjë webfaqe në internet ose aplikacion mobil dhe ne nuk do të jemi
			palë ose në çfarëdo mënyre të jemi të përgjegjshëm për monitorimin e çdo
			transaksioni midis jush dhe çdo ofruesi të produkteve ose shërbimeve të
			palës së tretë.
		</p>
		<p class="dark-paragraph mb-3">
			Në asnjë rast nuk do të jemi përgjegjës ndaj jush ose ndonjë palë të tretë
			për ndonjë dëmtim të drejtpërdrejtë, indirekt, përfshirë por duke mos u
			kufizuar në humbjen e të dhënave ose dëmet e tjera që vijnë nga përdorimi
			juaj i webfaqes tonë, edhe nëse ne jemi paralajmëruar për mundësinë e
			dëmeve të tilla.
		</p>
		<p class="dark-paragraph mb-5">
			Ne nuk do të jemi përgjegjës ose përgjegjës për ndonjë humbje, dëmtim,
			vonesë ose mos veprim të shkaktuar nga ndonjë shkak që është jashtë
			kontrollit tonë të arsyeshëm.
		</p>
		<p class="heading4 mb-3">
			PËRGJEGJËSIA JUAJ
		</p>
		<p class="dark-paragraph mb-3">
			Ju pranoni të mbroni dhe të dëmshpërbleni Shoqatën e Sigurimeve të Kosovës
			në rast se ne do të pësojmë ndonjë dëm si rezultat i:
		</p>
		<p class="dark-paragraph">
			• shkeljes së këtyre termave dhe kushteve nga ana e juaj;
		</p>
		<p class="dark-paragraph">
			• shkeljes së ndonjë ligji tjetër të aplikueshmë nga ana e juaj; dhe
		</p>
		<p class="dark-paragraph mb-3">• përdorimit të webfaqes tonë.</p>
		<p class="dark-paragraph mb-5">
			Po ashtu ju pranoni të mbroni dhe dëmshpërbleni Shoqatën e Sigurimeve të
			Kosovës nga çdo kërkesë e palës së tretë, përgjegjësi, dëmshpërblim,
			shpenzime dhe kosto të shkaktuar nga ose që rrjedhin nga përdorimi juaj i
			kësaj webfaqe në internet ose materialeve në një mënyrë jo të autorizuar
			shprehimisht nga këto terma dhe kushte ose shkeljes së këtyre termave dhe
			kushteve, ndonjë ligji, ose të drejtave të një pale të tretë.
		</p>
		<p class="heading4 mb-3">
			ZGJIDHJA E MOSMARRËVESHJEVE DHE KOMPETENCA E GJYKATËS
		</p>
		<p class="dark-paragraph mb-3">
			Këto terma dhe kushte dhe përdorimi i webfaqës rregullohen dhe
			interpretohen në përputhje me legjislacionin pozitiv në Republikën e
			Kosovës.
		</p>
		<p class="dark-paragraph mb-3">
			Nëse ndonjë dispozitë ose pjesë e një dispozite të këtyre termave dhe
			kushteve përcaktohet të jetë e kundërligjshme, e pavlefshme ose e
			pazbatueshme, kjo dispozitë ose një pjesë e dispozitës konsiderohet e
			ndarë nga këto pjesa tjetër e termave dhe kushteve dhe nuk ndikon në
			vlefshmërinë dhe zbatueshmërinë e dispozitave tjera.
		</p>
		<p class="dark-paragraph mb-3">
			Në rast kontesti ndërmjet shoqatës dhe juve, në mënyrë që të përshpejtohet
			zgjidhja e mosmarrëveshjes dhe të evitohen shpenzimet gjyqësore, çdo
			mosmarrëveshje ose kërkese në lidhje me këto terma dhe kushte (secila një
			'Mosmarrëveshje' dhe kolektivisht, 'Mosmarrëveshjet') të kërkuara nga ju
			ose ne (individualisht, një 'Palë' dhe kolektivisht , 'Palët'), palët bien
			dakord që së pari të përpiqen të negociojnë çdo mosmarrëveshje joformale
			për të paktën 30 ditë përpara se të inicohet procedurë gjyqësore. Bisedime
			të tilla joformale fillojnë me njoftimin me shkrim nga njëra palë tek pala
			tjetër.
		</p>
		<p class="dark-paragraph mb-5">
			Në rast se edhe negociatat nuk janë të mjaftueshme për të zgjidhur
			mosmarrëveshjen/t, palët mund t’i drejtohen Gjykatës Themelore në
			Prishtinë.
		</p>
		<p class="heading4 mb-3">KONTAKTI</p>
		<p class="dark-paragraph mb-1">
			Për të zgjidhur një ankesë në lidhje me webfaqen ose për të marrë
			informacione të mëtejshme në lidhje me përdorimin e webfaqes, ju lutemi na
			kontaktoni në:
		</p>
		<p class="dark-paragraph mb-1">
			Shoqata e Sigurimeve të Kosovës
		</p>
		<p class="dark-paragraph mb-1">Adresa:</p>
		<p class="dark-paragraph mb-1">
			Tel:
		</p>
		<p class="dark-paragraph mb-1">
			Email:
		</p>
		<p class="dark-paragraph mb-1">
			Përditësuar më: 07.05.2020
		</p>
	</div>
</div>
